import { render, staticRenderFns } from "./internal-transfer-tab.vue?vue&type=template&id=0a2227b3&"
import script from "./internal-transfer-tab.vue?vue&type=script&lang=js&"
export * from "./internal-transfer-tab.vue?vue&type=script&lang=js&"
import style0 from "./internal-transfer-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "internal-transfer-tab.vue"
export default component.exports